module.exports = __webpack_public_path__ + "img/img-140.f331386e.png";